import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { OrganizationSettingsEditMemberModel } from './organization-settings-edit-member.model';
import { ReprezentantOrganizacji } from '../../../../../shared/models/reprezentant-organizacji';
import { RolaReprezentantaOrganizacji } from '../../../../../shared/enums/rola-reprezentanta-organizacji.enum';

export class OrganizationSettingsEditMemberFormBuilder {
  public static createFormGroup(
    reprezentantOrganizacji?: ReprezentantOrganizacji,
  ): FormGroup<OrganizationSettingsEditMemberModel> {
    const fg = new FormGroup<OrganizationSettingsEditMemberModel>({
      id: new FormControl(reprezentantOrganizacji?.idBeneficjenta || null),
      email: new FormControl(reprezentantOrganizacji?.email || null),
      pesel: new FormControl(reprezentantOrganizacji?.pesel || null),
      role: new FormControl(
        reprezentantOrganizacji?.rola || null,
        Validators.required,
      ),
      instytucje: new FormArray<FormControl<boolean | null>>([]),
    });

    fg.setValidators(
      OrganizationSettingsEditMemberFormBuilder.atLeastOneInstitutionIfOupValidator,
    );

    return fg;
  }

  private static atLeastOneInstitutionIfOupValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (!control) return null;
    const fg = control as FormGroup<OrganizationSettingsEditMemberModel>;

    const rola = fg.controls.role.value;
    const instytucje = fg.controls.instytucje.controls;

    if (rola !== RolaReprezentantaOrganizacji.OUP) {
      return null;
    }

    if (!instytucje || !Array.isArray(instytucje)) return null;

    const hasSelected = instytucje.some((i: any) => i.value === true);

    return hasSelected ? null : { atLeastOneInstitutionRequired: true };
  }
}
